import React, {useEffect} from 'react';
import {isEmpty, truncate} from 'lodash';
import {PageHelmet} from 'components/Pages';
import DataLayerPush from 'utils/gtm';
import useGetCBKeyLocation from './useGetCBKeyLocation';
import {HELMET_DESC_LIMIT} from 'configs/limits';

function CBHelmet(props) {
  const {isLoading: cbLoading, data: certificationBody} = props;

  const {allLoading: officeLoading, data: offices} = useGetCBKeyLocation();
  const allLoading = cbLoading && officeLoading;

  const {eventView} = DataLayerPush;

  useEffect(() => {
    if (!allLoading && !isEmpty(certificationBody) && !isEmpty(offices)) {
      const {certification_bodies_id, certification_bodies_name, country_name} =
        certificationBody;
      const {data: dataOffice} = offices || {};

      const headOffice = (dataOffice || []).find(
        (office) => office.office_type === 'Head Office'
      );

      const {country_name: countryHeadOffice, city: cityHeadOffice} =
        headOffice || {};

      eventView({
        viewLocation: window.location.pathname,
        viewEntityName: certification_bodies_name,
        viewEntityId: certification_bodies_id,
        viewEntityCountry: country_name || countryHeadOffice || undefined,
        viewEntityCity: cityHeadOffice || undefined,
      });
    }
  }, [allLoading, certificationBody, offices]);

  if (allLoading) return null;

  const {
    certification_bodies_name,
    certification_bodies_acronym,
    certification_bodies_desc: cbDescription,
    country_name,
  } = certificationBody;
  const name = [certification_bodies_name, certification_bodies_acronym]
    .filter((v) => v)
    .join(' - ');

  const truncatedDesc = truncate(cbDescription, {length: HELMET_DESC_LIMIT});
  const defaultDesc = `Explore accredited certifications from ${name} based in ${country_name} on IAF CertSearch. Access a wealth of standards, schemes, and technical sector insights tailored to your industry.`;

  const title = `${name} - IAF Certification Body`;
  const description = !!cbDescription ? truncatedDesc : defaultDesc;

  return <PageHelmet title={title} description={description} />;
}

export default CBHelmet;
